export default "__VITE_ASSET__WzGJwAvE__"